import { useEffect, useState } from 'react';

/**
 * @param {string} id - The ID of the element to observe.
 * @param {number} threshold - A threshold value for the IntersectionObserver.
 * @returns {object} - Returns visibility and position states.
 */

const useVisibilityObserver = (id: string, threshold: number) => {
  const [isVisible, setIsVisible] = useState(false);
  const [isAbove, setIsAbove] = useState(false);
  const [isBelow, setIsBelow] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        setIsVisible(entry.isIntersecting);

        const rect = entry.boundingClientRect;
        const viewportHeight = window.innerHeight;

        // Viewport is above the element (element is below viewport)
        setIsAbove(rect.top > viewportHeight);

        // Viewport is below the element (element is above viewport)
        setIsBelow(rect.bottom < 0);
      },
      { threshold }
    );

    const element = document.getElementById(id);
    if (element) {
      observer.observe(element);
    }

    return () => {
      if (element) {
        observer.unobserve(element);
      }
    };
  }, [id, threshold]);

  return { isVisible, isAbove, isBelow };
};

export default useVisibilityObserver;
